/* Buying block pages. A calm rotating reassurance strip: paused on hover, focus and
   offscreen, stopped for good after two full rounds or a click on « next », never
   started with reduced motion. No pause button (Valentin, 02/10): the strip stops by
   itself. « Écrivez-nous » opens the Atrium chat when the page has it
   (window.atriumChat.ouvrir, layout/theme.liquid), else the mailto link stays.
   No dependency, no purchase state, no automatic announcement to screen readers. */
(() => {
  if (customElements.get('museau-reassurance')) return;
  customElements.define('museau-reassurance', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const on = (target, event, handler) => target.addEventListener(event, handler, { signal: this.events.signal });
      this.items = [...this.querySelector('[data-reassurance-items]').children];
      this.track = this.querySelector('[data-reassurance-items]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.shown = 0;
      this.paused = false;
      this.visible = false;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.querySelector('[data-reassurance-actions]').hidden = this.items.length < 2;
      on(this.querySelector('[data-reassurance-next]'), 'click', () => {
        this.paused = true;
        this.track.setAttribute('aria-live', 'polite');
        this.show(this.index + 1);
      });
      this.querySelectorAll('[data-reassurance-chat]').forEach(link => on(link, 'click', event => {
        const chat = window.atriumChat;
        if (!chat || typeof chat.ouvrir !== 'function') return;
        event.preventDefault();
        chat.ouvrir();
      }));
      on(this, 'pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => this.schedule());
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.show(0);
    }
    show(index) {
      this.index = index % this.items.length;
      this.items.forEach((item, i) => { item.hidden = i !== this.index; });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.shown >= this.items.length * 2) this.paused = true;
      if (this.paused || this.motion.matches || this.hovered || this.focused || !this.visible || document.hidden || this.items.length < 2) return;
      this.track.setAttribute('aria-live', 'off');
      this.timer = setTimeout(() => { this.shown += 1; this.show(this.index + 1); }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.events?.abort();
    }
  });
})();
